import React from "react";
import { Card, Icon, PageHeader } from "@nelurio/ui";
import { useI18n } from "@nelurio/i18n";
import { Link } from "react-router";

const items = [
  { to: "/planner", icon: "calendar", titleKey: "nav.planner", descKey: "planner.subtitle" },
  { to: "/library", icon: "library", titleKey: "nav.library", descKey: "library.empty" },
  { to: "/focus", icon: "timer", titleKey: "nav.focus", descKey: "focus.subtitle" },
  { to: "/progress", icon: "chart", titleKey: "nav.progress", descKey: "progress.subtitle" },
  { to: "/academic-path", icon: "route", titleKey: "nav.academicPath", descKey: "academic.hubDesc" },
  { to: "/settings", icon: "settings", titleKey: "nav.settings", descKey: "settings.hubDesc" }
] as const;

export function MorePage() {
  const { t } = useI18n();
  return (
    <div className="page-stack rise">
      <PageHeader title={t("nav.more")} subtitle={t("more.subtitle")} />
      <div className="more-hub">
        {items.map((item, index) => (
          <Link to={item.to} key={item.to} className="more-hub__card tilt-card" style={{ "--delay": `${index * 60}ms` } as React.CSSProperties}>
            <span className="more-hub__icon"><Icon name={item.icon} /></span>
            <div>
              <strong>{t(item.titleKey)}</strong>
              <small>{t(item.descKey)}</small>
            </div>
            <Icon name="chevronRight" size={16} className="more-hub__arrow" />
          </Link>
        ))}
      </div>
      <Card className="more-tip">
        <span>✦</span>
        <p>{t("more.tip")}</p>
      </Card>
    </div>
  );
}
